module.exports = __webpack_public_path__ + "a4c733ec4baef9ad3896d4e34a8a5448.png";